export default [
  {
    path: '/app/drawMap',
    name: 'drawMap',
    components: {
      default: () => import('../../views/drawMap/index.vue')
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/drawMap.js